<template>
  <JobListPreview
    :HeaderProps="{ title: $t('servicesystem.common_objects.job.open_jobs'), icon: 'mdi-briefcase-clock' }"
    :JobList="jobList" :loading="loading">
  </JobListPreview>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import JobListPreview from "@/components/Preview/JobListPreview.vue";

export default {
  name: "ActiveJobsPreview",
  props: {
    id: [Number, String],
    customer: Boolean,
    machine: Boolean,
  },
  components: { JobListPreview },
  mixins: [clientAPI],

  data: () => ({
    loading: true,
    jobList: [],
    minStatusId: 19,
    maxStatusId: 69,
  }),

  mounted() {
    if (this.id) {
      this.jobList = [];
      this.getJobs();
    }
  },

  methods: {
    getJobs() {
      this.loading = true;
      var filter = {
        ItemsPerPage: 99,
        Page: 1,
        JobStatusIdList: this.statuses.map(x => x.Id),
        OrderDepartmentIdList: this.storedOrderDeparmentDefault,
      }
      if (this.customer) {
        filter.CustomerIdList = [this.id];
      }
      else if (this.machine) {
        filter.MachineIdList = [this.id];
      }
      this.getJobListFromFilter(filter)
        .then((response) => {
          this.jobList = response.Content;
        })
        .catch((/*exception*/) => {
          this.jobList = false;
        })
        .finally(() => (this.loading = false));
    },
  },

  computed: {
    statuses() {
      var statuses = Object.assign([], this.$store.getters["LookUpStore/JobStatusList"]);
      const min = this.minStatusId;
      const max = this.maxStatusId;
      var filteredstatuses = statuses.filter(x => x.Id > min && x.Id < max);
      return filteredstatuses;
    },
    storedOrderDeparmentDefault() {
      return this.$store.getters["prefrences/Prefrence"]("JobListFilterOrderDepartmentDefault");
    },
  },

  watch: {
    id: function () {
      this.getJobs();
    },
  },
};
</script>